import { apiDelete } from "../client";
import { useMutation } from "@tanstack/react-query";

export const useDeleteExamSet = () => {
  return useMutation({
    mutationFn: (id: string) =>
      apiDelete<{ message: string }>(`/exam_sets/${id}`),
  });
};

export default useDeleteExamSet;
